import { Button, CircularProgress, IconButton } from "@mui/material";
import styles from "./DocumentDownload.module.scss";
import MainContext from "../../context/mainContext";
import documentsService from "../../services/document.service";
import { useContext, useState } from "react";
import { DocumentIcon } from "../../assets/icons";

interface Props {
  documentId?: number;
  templateCode?: string;
  type?: "icon" | "button" | undefined;
  text?: string;
}

const DocumentDownloadButton: React.FC<Props> = ({
  documentId,
  templateCode,
  type,
  text,
}) => {
  const { service } = useContext(MainContext);
  const [downloading, setDownloading] = useState(false);

  const download = () => {
    if (templateCode != null) {
      service(() => documentsService.downloadTemplate(templateCode!), {
        loader: setDownloading,
      });
    } else {
      service(() => documentsService.download(documentId!), {
        loader: setDownloading,
      });
    }
  };

  return type === "button" ? (
    <Button
      key={`lang_download_id_${documentId ?? templateCode}`}
      onClick={(e) => {
        e.stopPropagation();
        download();
      }}
    >
      {text}
    </Button>
  ) : downloading ? (
    <CircularProgress className={styles.circular} />
  ) : (
    <IconButton
      onClick={(e) => {
        e.stopPropagation();
        download();
      }}
    >
      <DocumentIcon />
    </IconButton>
  );
};

export default DocumentDownloadButton;
